<template>
  <div class="add-provider">
    <a-modal
      :title="title"
      v-model="visible"
      :width="600"
      :maskClosable="false"
      :bodyStyle="{'max-height': '500px', 'overflow-y': 'auto'}"
      okText="确定"
      @cancel="closeAction"
      @ok="addCertificatethandleOk"
    >
      <a-form :form="form">
          <div :class="isError? 'has-error': ''" style="margin-bottom: 10px;">
              <span style="color: #000;margin-left: 35px;"><i style="color: red">* </i>供应商名称：</span>
              <a-select  style="width: 275px;margin-left: 10px;" v-model="formObj.name" @blur="providerBlur" @search="providerChange" autoComplete="ssaa"
                placeholder="请选择供应商" showSearch showArrow :disabled="status != 0"
              >
              <a-select-option v-for="(item, index) in providerList" :key="index" :value="item">{{item}}</a-select-option>
            </a-select>
            <p v-if="isError" class="has-error">供应商不能为空</p>
          </div>
        <a-form-item :labelCol="{span: 6}" :wrapperCol="{ span: 12}" label="省市" colon >
          <a-cascader
          v-decorator="[
              'region',
              {
                rules: [
                  { required: true, message: '省市不能为空' },
                ],
                initialValue: regionVlaue
              }
            ]"
            :options="cascaderOptions" 
            @change="regionOnChange" 
            :showSearch="{filter}" 
            autoComplete="ssosan"
            placeholder="请选择地区"
          />
        </a-form-item>
        <a-form-item label="认证联络员" :labelCol="{span: 6}" :wrapperCol="{ span: 12}">
          <a-input
            autoComplete="n212ns"
            v-decorator="[
              'contacts',
              {
                rules: [
                  { required: true, message: '认证联络员不能为空' },
                ],
                initialValue: formObj.contacts
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="手机号码" :labelCol="{span: 6}" :wrapperCol="{ span: 12}">
          <a-input
            autoComplete="nass"
            :maxLength="11"
            v-decorator="[
              'userPhones',
              {
                rules: [
                  { required: true, message: '手机号码不能为空' },
                ],
                initialValue: formObj.userPhones
              }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="备注" :labelCol="{span: 6}" :wrapperCol="{ span: 12}">
          <a-textarea v-decorator="['remark', {initialValue: formObj.remark}]"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { addProvider, editProvider, getDetail, getProviderNameList } from '@/api/provider'

import { getToken, setselectNearest } from "@/utils/auth";
import { parseJson } from "@/utils";

export default {
  props: {
    isAdd: Boolean,
    id: String,
    status: String
  },
  components: {
  },
  data() {
    return {
      addFormItemLayout: {
        labelCol: {
          span: 6
        },
        wrapperCol: {
          span: 16
        }
      },
      certificateUploadList: [],
      doUpload: "/api/ossPrivateConfig", //上传文件api
      headers: {},
      visible: true,
      form: this.$form.createForm(this),
      certificateTagsList: [],
      formObj: {
        'name': '',
        'region': '',
        'contacts': '',
        'userPhones': '',
        'remark': ''
      },
      roleId:'',
      roles: [],
      certList: [],
      cascaderOptions: [],
      selectedRegion:'',
      regionVlaue: [],
      providerList: [],
      title: '添加供应商',
      providerName: '',
      isError: false
    };
  },
  created() {
    this.getProviderNameList();
    if (!this.isAdd) {
      this.title = '编辑供应商';
      this.getDetail(this.id);
    }
  },
  mounted() {
    let userMsg = this.$store.state.user.user;
    this.roles = userMsg.roles;
    this.roleId = this.$store.state.user.roles
    this.cascaderOptions = this.$province
  },
  methods: {
    providerChange(e) {
      this.formObj.name = e;
    },
    providerBlur(e) {
      this.formObj.name = e;
    },
    getProviderNameList() {
      getProviderNameList()
        .then(res => {
          this.providerList = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    getDetail(id) {
      getDetail(id)
        .then(res => {
          this.formObj.name = res.name;
          this.formObj.contacts = res.contacts;
          this.formObj.userPhones = res.userPhones;
          this.formObj.remark = res.remark;
          this.regionVlaue = res.regionCodes;
        })
        .catch(error => {
          console.log(error);
        })
    },
    regionOnChange(value, selectedOptions){
      this.regionVlaue = value
      if(selectedOptions){
        let selectedLabel = []
        selectedOptions.filter(item => {
          selectedLabel.push(item.value)
        })
        this.selectedRegion = selectedLabel.join(',')
      }else{
        this.selectedRegion = ''
      }
    },
    /**
     * 实现地区搜索
     */
    filter(inputValue, path) {
      return path.some(
        option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1,
      );
    },
    getOdmCertificateList() {
      getOdmCertificateList()
        .then(res => {
          this.certList = res;
        })
        .catch(error => {
          console.log(error);
        })
    },
    closeAction() {
        this.$emit('hideAction');
    },
    // 新增提交
    addCertificatethandleOk() {
      this.form.validateFields((err, params) => {
        if (this.formObj.name == '') {
          this.isError = true;
          return;
        } else {
          this.isError = false;
        }
        if (!err) {
          this.formObj.contacts = params.contacts;
          if (params.remark) {
            this.formObj.remark = params.remark;
          }
          this.formObj.userPhones = params.userPhones;
          this.formObj.region = params.region.join(',');
          if (this.isAdd) {
            this.addProvider(this.formObj);
          } else {
            this.formObj.id = this.id;
            this.editProvider(this.formObj);
          }
        }
      });
    },
    //新增接口
    addProvider(params) {
      addProvider(params)
        .then(res => {
          this.$message.success("新建成功");
          this.$emit("addSuccess"); 
          this.$emit('hideAction');
        })
        .catch(error => {
          console.log(error.message);
        });
    },
    editProvider(params) {
      editProvider(params)
        .then(res => {
          this.$message.success("更新成功");
          this.$emit("addSuccess"); 
          this.$emit('hideAction');
        })
        .catch(error => {
          console.log(error.message);
        });
    },
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
.item-type {
    display: inline-block;
    width: 200px;
    overflow: hidden;/*超出部分隐藏*/
    white-space: nowrap;/*不换行*/
    text-overflow:ellipsis;
    vertical-align: middle;
    cursor: pointer;
}
.ant-form-item {
     margin-bottom: 8px;
}
.has-error p {
  color: #f5222d;
  text-indent: 145px;
}
</style>